// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3BZn-","errors":"Errors_errors__3FYg0"};